import { cyrb53 } from "@/utils/cyrb53";

// Chat channel icons: names match the svg files in src/app/components/icons/chat-icons.
export const CHAT_ICONS = [
  { name: "MathFunction", keywords: "math function f formula" },
  { name: "Fx", keywords: "math function fx formula" },
  { name: "DefineAs", keywords: "define variable math" },
  { name: "Text", keywords: "text type letter t" },
  { name: "Image", keywords: "image picture photo" },
  { name: "Play", keywords: "play video embed run" },
  { name: "Checklist", keywords: "checklist checkbox todo task done" },
  { name: "EmbedCode", keywords: "embed code html tag" },
  { name: "Code", keywords: "code terminal prompt console" },
  { name: "Note", keywords: "note lines text" },
  { name: "InsertBlock", keywords: "insert block add plus" },
  { name: "List", keywords: "list bullets items" },
  { name: "Graph", keywords: "graph chart plot curve" },
  { name: "Parabola", keywords: "graph parabola curve plot" },
  { name: "Axes", keywords: "graph axes plot coordinates" },
  { name: "LinearGraph", keywords: "graph line linear plot" },
  { name: "Crosshair", keywords: "graph axes cross plus plot" },
  { name: "SineWave", keywords: "graph sine wave plot" },
  { name: "ArrowLeft", keywords: "arrow left back" },
  { name: "ArrowRight", keywords: "arrow right forward next" },
  { name: "ArrowUp", keywords: "arrow up" },
  { name: "ArrowDown", keywords: "arrow down" },
  { name: "FlipVertical", keywords: "flip vertical mirror" },
  { name: "FlipHorizontal", keywords: "flip horizontal mirror" },
  { name: "Info", keywords: "info information i help" },
  { name: "Camera", keywords: "camera photo record" },
  { name: "Waveform", keywords: "wave audio sound waveform" },
  { name: "Table", keywords: "table grid spreadsheet" },
  { name: "Dot", keywords: "dot point bullet circle" },
  { name: "More", keywords: "more dots ellipsis menu" },
  { name: "Bot", keywords: "ai bot robot assistant" },
  { name: "BotWink", keywords: "ai bot robot wink" },
  { name: "BotGlasses", keywords: "ai bot robot glasses" },
  { name: "BotSmile", keywords: "ai bot robot smile" },
  { name: "BotRound", keywords: "ai bot robot round" },
  { name: "BotBig", keywords: "ai bot robot big eyes" },
  { name: "Smile", keywords: "smile happy face emoji" },
  { name: "Wink", keywords: "wink face emoji" },
  { name: "UpsideDown", keywords: "upside down face emoji silly" },
  { name: "Neutral", keywords: "neutral face emoji meh" },
  { name: "Frown", keywords: "frown sad face emoji" },
  { name: "Confused", keywords: "confused face emoji" },
  { name: "Flushed", keywords: "flushed surprised face emoji eyes" },
  { name: "Grin", keywords: "grin happy face emoji laugh" },
  { name: "Laugh", keywords: "laugh joy tears face emoji lol" },
  { name: "Surprised", keywords: "surprised wow face emoji" },
  { name: "Cry", keywords: "cry sad tear face emoji" },
  { name: "Disappointed", keywords: "disappointed sad face emoji" },
  { name: "User", keywords: "user account profile person" },
  { name: "Guest", keywords: "guest user person outline" },
  { name: "Users", keywords: "users members team people group" },
  { name: "Group", keywords: "group people team members" },
  { name: "Students", keywords: "students class people group" },
  { name: "Anonymous", keywords: "anonymous person user dots" },
  { name: "Equal", keywords: "equal equals math symbol" },
  { name: "AlmostEqual", keywords: "almost equal approximately math symbol" },
  { name: "Minus", keywords: "minus subtract dash math symbol" },
  { name: "Plus", keywords: "plus add math symbol" },
  { name: "Multiply", keywords: "multiply times cross math symbol" },
  { name: "GreaterOrEqual", keywords: "greater than or equal inequality math symbol" },
  { name: "ForAll", keywords: "for all universal quantifier logic math" },
  { name: "Exists", keywords: "there exists existential quantifier logic math" },
  { name: "Sum", keywords: "sum sigma summation math" },
  { name: "Union", keywords: "union set math" },
  { name: "SquareCap", keywords: "square cap intersection meet math" },
  { name: "ElementOf", keywords: "element of in set membership math" },
  { name: "Alpha", keywords: "alpha greek letter math" },
  { name: "Beta", keywords: "beta greek letter math" },
  { name: "Lambda", keywords: "lambda greek letter math" },
  { name: "Mu", keywords: "mu greek letter math micro" },
  { name: "Psi", keywords: "psi greek letter math physics" },
  { name: "Pi", keywords: "pi greek letter math circle" },
  { name: "Atom", keywords: "atom physics science chemistry" },
  { name: "Chip", keywords: "chip processor cpu hardware computer" },
  { name: "Cube", keywords: "cube box 3d geometry" },
  { name: "PieChart", keywords: "pie chart data statistics" },
  { name: "BarChart", keywords: "bar chart data statistics graph" },
  { name: "CubeDashed", keywords: "cube dashed 3d placeholder geometry" },
  { name: "Puzzle", keywords: "puzzle piece game" },
  { name: "BeachUmbrella", keywords: "beach umbrella parasol summer vacation" },
  { name: "Quill", keywords: "quill feather pen writing" },
  { name: "Headphones", keywords: "headphones audio music listen" },
  { name: "Car", keywords: "car vehicle drive" },
  { name: "Comet", keywords: "comet space meteor star" },
  { name: "Number0", keywords: "number zero 0 digit circle" },
  { name: "Number1", keywords: "number one 1 digit circle" },
  { name: "Number2", keywords: "number two 2 digit circle" },
  { name: "Number3", keywords: "number three 3 digit circle" },
  { name: "Number4", keywords: "number four 4 digit circle" },
  { name: "Number5", keywords: "number five 5 digit circle" },
  { name: "Number6", keywords: "number six 6 digit circle" },
  { name: "Number7", keywords: "number seven 7 digit circle" },
  { name: "Number8", keywords: "number eight 8 digit circle" },
  { name: "Number9", keywords: "number nine 9 digit circle" },
  { name: "Number10", keywords: "number ten 10 digit circle" },
  { name: "QuestionCircle", keywords: "question help support circle" },
  { name: "Brightness", keywords: "brightness sun light settings" },
  { name: "CircleX", keywords: "circle x cross times close tensor" },
  { name: "Ban", keywords: "ban block forbidden empty set null" },
  { name: "Target", keywords: "target bullseye circle ring" },
  { name: "CirclePlus", keywords: "circle plus add direct sum" },
  { name: "CircleMinus", keywords: "circle minus remove subtract" },
  { name: "AsteriskCircle", keywords: "asterisk circle star snowflake" },
  { name: "Focus", keywords: "focus frame crosshair center" },
  { name: "Measure", keywords: "measure ruler width dimension" },
  { name: "Gauge", keywords: "gauge speedometer meter dashboard" },
  { name: "Keyboard", keywords: "keyboard hotkeys shortcuts type" },
  { name: "MapPin", keywords: "map pin location place" },
  { name: "ThumbsUp", keywords: "thumbs up like approve" },
  { name: "Translate", keywords: "translate language" },
  { name: "Clover", keywords: "clover luck leaf plant" },
  { name: "TShirt", keywords: "t-shirt shirt clothes" },
  { name: "Cheese", keywords: "cheese food" },
  { name: "RiceBowl", keywords: "rice bowl food meal" },
  { name: "Home", keywords: "home house" },
  { name: "Store", keywords: "store shop market" },
  { name: "Skyscraper", keywords: "skyscraper building tower city" },
  { name: "University", keywords: "university school campus building" },
  { name: "Factory", keywords: "factory industry building" },
  { name: "Building", keywords: "building office apartment" },
  { name: "Download", keywords: "download arrow save" },
  { name: "Upload", keywords: "upload arrow share" },
  { name: "Contrast", keywords: "contrast theme half circle" },
  { name: "Fork", keywords: "fork branch git" },
  { name: "Copyright", keywords: "copyright c circle" },
  { name: "Angle", keywords: "angle right 90 geometry" },
  { name: "Triangle", keywords: "triangle angles geometry shape" },
  { name: "SquareDiagonal", keywords: "square diagonal geometry shape" },
  { name: "Circle", keywords: "circle radius geometry shape" },
  { name: "Trapezoid", keywords: "trapezoid geometry shape" },
  { name: "Cone", keywords: "cone geometry 3d shape" },
  { name: "Perpendicular", keywords: "perpendicular right angle geometry" },
  { name: "TriangleHeight", keywords: "triangle height altitude geometry" },
  { name: "RightTriangle", keywords: "right triangle geometry" },
  { name: "Cylinder", keywords: "cylinder geometry 3d shape" },
  { name: "Pyramid", keywords: "pyramid geometry 3d shape" },
  { name: "Ruler", keywords: "ruler measure length geometry" },
  { name: "Edit", keywords: "edit pencil write compose" },
  { name: "Star", keywords: "star favorite" },
  { name: "Sparkles", keywords: "sparkles stars magic ai" },
  { name: "Attach", keywords: "attach paperclip attachment" },
  { name: "Email", keywords: "email mail envelope message" },
  { name: "Warning", keywords: "warning alert caution triangle" },
  { name: "ChatBubble", keywords: "chat bubble message talk" },
  { name: "ChatLines", keywords: "chat bubble message lines text" },
  { name: "ChatCheck", keywords: "chat bubble message check done" },
  { name: "ChatPlus", keywords: "chat bubble message add plus new" },
  { name: "ChatQuestion", keywords: "chat bubble message question help" },
  { name: "ChatInfo", keywords: "chat bubble message info" },
  { name: "Calendar", keywords: "calendar date schedule" },
  { name: "Search", keywords: "search magnifier find" },
  { name: "Bookmark", keywords: "bookmark save" },
  { name: "Scissors", keywords: "scissors cut" },
  { name: "Lock", keywords: "lock locked private secure" },
  { name: "Unlock", keywords: "unlock unlocked open" },
  { name: "Bulb", keywords: "bulb light idea lamp" },
  { name: "BulbOn", keywords: "bulb light idea lamp on bright" },
  { name: "BulbIdea", keywords: "bulb light idea lamp spark" },
  { name: "Book", keywords: "book wiki read library" },
  { name: "Archive", keywords: "archive box clipboard storage" },
  { name: "Trash", keywords: "trash bin delete garbage" },
  { name: "Flag", keywords: "flag marker report" },
  { name: "Megaphone", keywords: "megaphone announce announcement" },
  { name: "Bell", keywords: "bell notification alert ring" },
  { name: "Fire", keywords: "fire flame hot" },
  { name: "Umbrella", keywords: "umbrella rain weather" },
  { name: "Balloon", keywords: "balloon birthday party celebrate" },
  { name: "Carrot", keywords: "carrot vegetable food" },
  { name: "Strawberry", keywords: "strawberry fruit berry food" },
  { name: "Apple", keywords: "apple fruit food" },
  { name: "Coffee", keywords: "coffee cup tea drink" },
  { name: "Croissant", keywords: "croissant bread bakery food" },
  { name: "Shrimp", keywords: "shrimp prawn seafood food" },
  { name: "Moon", keywords: "moon night sleep dark" },
  { name: "Sun", keywords: "sun day light bright weather" },
  { name: "Cloud", keywords: "cloud weather sky" },
  { name: "Rain", keywords: "rain weather cloud" },
  { name: "Snow", keywords: "snow snowflake freezing cold winter" },
  { name: "Lightning", keywords: "lightning bolt thunder storm energy" },
  { name: "Music", keywords: "music note song audio" },
  { name: "Glasses", keywords: "glasses eyewear read" },
  { name: "Bike", keywords: "bike bicycle cycling sport" },
  { name: "Stethoscope", keywords: "stethoscope doctor medical health" },
  { name: "Bandage", keywords: "bandage patch plaster medical" },
  { name: "Crown", keywords: "crown king queen royal" },
  { name: "AlarmClock", keywords: "alarm clock time wake" },
  { name: "Timer", keywords: "timer stopwatch time" },
  { name: "GraduationCap", keywords: "graduation cap education school university" },
  { name: "Paw", keywords: "paw pet animal dog cat" },
  { name: "GameController", keywords: "game controller gaming play" },
  { name: "Ghost", keywords: "ghost spooky halloween" },
  { name: "FileText", keywords: "file document text page" },
  { name: "FilePdf", keywords: "file pdf document" },
  { name: "FileVideo", keywords: "file video movie document" },
  { name: "FileAudio", keywords: "file audio sound document" },
  { name: "FileSpreadsheet", keywords: "file spreadsheet csv excel table document" },
  { name: "FileCode", keywords: "file code source document" },
  { name: "File", keywords: "file document blank page" },
  { name: "FileMath", keywords: "file math function formula document" },
  { name: "FileTex", keywords: "file tex latex document" },
  { name: "FileImage", keywords: "file image picture document" },
  { name: "AddFile", keywords: "add file new document plus" },
  { name: "FileInfo", keywords: "file info document i" },
  { name: "AppleLogo", keywords: "apple logo brand" },
  { name: "Google", keywords: "google logo brand" },
  { name: "GitHub", keywords: "github logo brand code" },
  { name: "X", keywords: "x twitter logo brand" },
  { name: "ChatGpt", keywords: "chatgpt openai logo brand ai" },
  { name: "Claude", keywords: "claude anthropic logo brand ai" },
  { name: "Slack", keywords: "slack logo brand chat" },
  { name: "Instagram", keywords: "instagram logo brand social" },
  { name: "Overleaf", keywords: "overleaf logo brand latex" },
  { name: "LinkedIn", keywords: "linkedin logo brand social" },
  { name: "Notion", keywords: "notion logo brand notes" },
] as const;

export type ChatIconName = (typeof CHAT_ICONS)[number]["name"];

export const CHAT_ICON_META_KEY = "icon";

const CHAT_ICON_NAMES = new Set<string>(CHAT_ICONS.map((icon) => icon.name));

export function isChatIconName(value: unknown): value is ChatIconName {
  return typeof value === "string" && CHAT_ICON_NAMES.has(value);
}

export function filterChatIcons(query: string): readonly (typeof CHAT_ICONS)[number][] {
  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return CHAT_ICONS;
  return CHAT_ICONS.filter((icon) => {
    const haystack = `${icon.name} ${icon.keywords}`.toLowerCase();
    return words.every((word) => haystack.includes(word));
  });
}

// Friendly subset for chats without a picked icon: no editor glyphs, symbols, files or logos.
export const DEFAULT_CHAT_ICON_POOL: readonly ChatIconName[] = [
  "Bot",
  "BotWink",
  "BotGlasses",
  "BotSmile",
  "BotRound",
  "BotBig",
  "Smile",
  "Wink",
  "UpsideDown",
  "Grin",
  "Laugh",
  "Surprised",
  "User",
  "Users",
  "Group",
  "Students",
  "Star",
  "Sparkles",
  "Calendar",
  "Bookmark",
  "Bulb",
  "BulbOn",
  "BulbIdea",
  "Book",
  "Flag",
  "Megaphone",
  "Bell",
  "Fire",
  "Umbrella",
  "Balloon",
  "Carrot",
  "Strawberry",
  "Apple",
  "Coffee",
  "Croissant",
  "Shrimp",
  "Moon",
  "Sun",
  "Cloud",
  "Rain",
  "Snow",
  "Lightning",
  "Music",
  "Glasses",
  "Bike",
  "Stethoscope",
  "Bandage",
  "Crown",
  "AlarmClock",
  "Timer",
  "GraduationCap",
  "Paw",
  "GameController",
  "Ghost",
];

// Chats without a picked icon get a stable one derived from their uid.
export function defaultChatIconName(uid: string): ChatIconName {
  return DEFAULT_CHAT_ICON_POOL[cyrb53(uid) % DEFAULT_CHAT_ICON_POOL.length];
}

/** The chat's picked icon from `meta`, else its uid-derived default. */
export function chatIconName({
  uid,
  meta,
}: {
  uid: string;
  meta?: Record<string, string> | null;
}): ChatIconName {
  const icon = meta?.[CHAT_ICON_META_KEY];
  return isChatIconName(icon) ? icon : defaultChatIconName(uid);
}
